import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Loan } from 'src/model/loan.model';

@Component({
    selector: 'app-legacy-epf-settlement',
    templateUrl: './legacy-epf-settlement.component.html',
    styleUrls: ['./legacy-epf-settlement.component.scss'],
    standalone: false
})
export class LegacyEpfSettlementComponent {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);

  @Input() loanList: Loan[] = [];
  @Output() passEntry = new EventEmitter<any>();

  disabledSubmit = false;

  containsError() {
    let error = "";
    for (let i = 0; i < this.loanList.length; i++) {
      if (this.loanList[i].LegacySettlement == 0 || this.loanList[i].LegacySettlement == undefined)
        error += "- Please fill in LEGACY SETTLEMENT for loan =" + this.loanList[i].ReceiptNumber;
      else if (this.loanList[i].LegacySettlement <= this.loanList[i].Principal)
        error += "\n- LEGACY SETTLEMENT for loan =" + this.loanList[i].ReceiptNumber + " is less than principal";
    }

    if (error != "")
      return "Please fix all these errors before proceed : \n" + error;
    else
      return error;
  }

  submit() {
    this.disabledSubmit = true;
    const error = this.containsError();
    if (error != "") {
      this.sharedService.openAlert(error, ALERT_TYPE.DANGER);
      this.disabledSubmit = false;
    }
    else {
      for (let i = 0; i < this.loanList.length; i++) {
        this.addLegacyEPFSettlement(this.loanList[i], i);
      }
    }
  }

  addLegacyEPFSettlement(loan: Loan, index: number) {
    const data = {
      "legacySettlement": loan.LegacySettlement
    }
    const xhr = this.restApi.postRequest(this.constructApi.getAddLegacyEPFSettlement(loan.ID), data)
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        //if success , then proceed
        if (xhr.status == 200) {
          //if last object is updated
          if (index == this.loanList.length - 1) {
            this.passEntry.emit(true)
            this.closeModal();
          }
        }
        else {
          //show error message
          this.sharedService.openAlert(JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER)
        }
      }
    }
  }

  closeModal() {
    this.activeModal.close();
  }
}
